import useSWR from "swr";

export const useOwnersList = (fleetId, objectId) =>
  useSWR(`Fleets/${fleetId}/insured-objects/${objectId}/lli-ownerships`);
